import { EmptyState, FlexColumn, Loading } from '@gorila-shared-ui/components';
import { useEffect } from 'react';
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import { getHistoricStateByGroup } from '../../../services/reportsService';
import { apiParamsState, isAllWorkspacesSelect } from '../../../storage/app';
import {
  loadingReportRouteState,
  reportEndDateState,
  reportFilterGroupState,
  reportHistoricState,
  reportHistoricStates,
  reportStartDateState,
} from '../../../storage/reports';
import { HistoricState } from '../../../types/currentState';
import { RouteReportTable } from './RouteReportTable';

export function RouteReportsByGroup() {
  const { css } = useStyles();
  const groupId = useRecoilValue(reportFilterGroupState);
  const endDate = useRecoilValue(reportEndDateState);
  const startDate = useRecoilValue(reportStartDateState);
  const apiParams = useRecoilValue(apiParamsState);
  const [loadingReportRoute, setLoadingReportRoute] = useRecoilState(loadingReportRouteState);
  const setReportHistorics = useSetRecoilState(reportHistoricStates);
  const resetReportHistorics = useResetRecoilState(reportHistoricStates);
  const isAllWorkspacesSelected = useRecoilValue(isAllWorkspacesSelect);
  const states = useRecoilValue(reportHistoricState(groupId))?.states;

  useEffect(() => {
    return () => {
      resetReportHistorics();
    };
  }, []);

  useEffect(() => {
    if (!groupId || !startDate || !endDate || !apiParams) return;
    const loadHistoricStates = async () => {
      setLoadingReportRoute(true);
      const { historicStates, error } = await getHistoricStateByGroup(
        apiParams.clientId,
        groupId,
        startDate,
        endDate,
        isAllWorkspacesSelected ? undefined : apiParams.subClientId,
      );
      const newHistorics: { [key: string]: { states: HistoricState[]; onlyEvents: boolean } } = {};
      if (!error) {
        newHistorics[groupId] = { states: historicStates ?? [], onlyEvents: false };
      }
      setReportHistorics(newHistorics);
      setLoadingReportRoute(false);
    };
    loadHistoricStates();
  }, [groupId, startDate, endDate]);

  if (loadingReportRoute) {
    return <Loading />;
  }

  if (!groupId) {
    return <EmptyState title="Selecciona un grupo para visualizar el reporte." />;
  }

  return (
    <FlexColumn
      gap={0}
      classNames={css({ flex: 1, overflow: 'hidden' })}
    >
      <RouteReportTable
        states={states}
        extended
      />
    </FlexColumn>
  );
}
